//グローバルオブジェクト
var g = {
  mainHost: $("#mainHost").attr("data-host"),
  //ERROR Window//
  errWindow: new ErrorWindow("通信に失敗しました。<br>再度お試しください。","Close"),
  btnIds: []  //ページ内感情ボタン格納用
}

//UA判定
if(navigator.userAgent.search(/iPhone/) != -1)g.ua = 'ios';
else if(navigator.userAgent.search(/Android/) != -1) g.ua = 'android';

//$(function(){
//  if(typeof g.mainHost == "undefined")
//  {
//    $.ajax({
//      type: "GET",
//      url: "/wp-json/common/get-host",
//      xhrFields: {withCredentials: true},
//      dataType: "json",
//      timeout: 10000
//    })
//    .always(function(result){
//      g.mainHost = result.hostname;
//      //cookie,UUIDを取得
//      getSegatoysCookie(onCookieLoadComplete, onCookieLoadFailed);
//    });
//  }
//  else
//  {
//    //cookie,UUIDを取得
//    getSegatoysCookie(onCookieLoadComplete, onCookieLoadFailed);
//  }
//});

//cookie,UUIDを取得
//getSegatoysCookie(onCookieLoadComplete, onCookieLoadFailed);

function onCookieLoadComplete(data)
{
  g.cookieObj = data;
  g.uuid = data.uuid;
  btnInit();
}

function onCookieLoadFailed(data)
{
  //console.error(data);
  btnInit();
  return false;
}


//空文字の場合は検索しない
$(document).on("click", "#cse-search-box .search-form__btn", function(e){
  if($("#cse-search-box .search-form__input").val() == "")
  {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
});

//感情ボタンのロード//
function btnInit()
{
  $("[class*='btn-interest'][data-id]").each(function(){
    g.btnIds.push($(this).attr("data-id"));
    if(typeof g.pageType == "undefined") g.pageType = $(this).attr("data-toy");
  });
  
  //ボタンがページ内に存在し、且つ、uuidの取得に成功していたらボタンデータを取得
  if(g.btnIds.length > 0 && typeof g.uuid != "undefined")
  {
    getBtnStatus(g.btnIds);
  }
}

/**
 * 感情ボタンステータス問い合わせ
 * @param btns {array} - 取得したいボタンidの配列
 */
function getBtnStatus(btns)
{
  $.ajax({
    type: "POST",
    url: "/wp-json/emotional-button/load-info",
    xhrFields: {withCredentials: true},
    dataType: "json",
    timeout: 10000,
    data: {
      type: g.pageType,
      ids: btns,
      uuid: g.uuid
    }
  })
  .done(function(result){
    var len = result.length;
    for(var i = 0; i < len; i++)
    {
      var btnInfo = result[i];
      var $btn = $("[class*='btn-interest'][data-id='" + btnInfo.id + "']");
      if(btnInfo.isVote) $btn.addClass("active");
      else $btn.removeClass("active isChecked");
      $btn.find("[class*='__score']").text(btnInfo.count);
      $btn.attr("data-label", btnInfo.label);
    }
  })
  .fail(function(result){
    //g.errWindow.open();
    return false;
  });
}

//Slider//
if(typeof $.fn["sliderPro"] != "undefined")
{
  //商品画像スライダーの設定
  var option_product = {
    buttons: false,
    arrows: true,
    fadeArrows: false,
    width: "100%",
    imageScaleMode: "contain",
    visibleSize: '100%',
    thumbnailWidth: 100
  };
  
  if($("#product-detail__slider .sp-slide").length == 2)
  {
    option_product.loop = false;
    $('#product-detail__slider').sliderPro(option_product);
  }
  else if($("#product-detail__slider .sp-slide").length > 1)
  {
    $('#product-detail__slider').sliderPro(option_product);
  }
  else
  {
    option_product.arrows = false;
    option_product.autoplay = false;
    option_product.touchSwipe = false;
    option_product.thumbnailTouchSwipe = false;
    option_product.thumbnailWidth = 0;
    option_product.thumbnailHeight = 0;
    
    $('#product-detail__slider').sliderPro(option_product);
  }
  
  //動画スライダ－の設定
  var option_movie = {
    buttons: false,
    touchSwipe: false,
    fadeCaption: false,
    forceSize: "fullWidth",
    width: "100%",
    autoHeight: true,
    imageScaleMode: "contain",
    visibleSize: '100%',
    //fade: true,
    arrows: false,
    fadeArrows: false,
    autoplay: false,
    loop: true,
    thumbnailWidth: 120,
    thumbnailHeight: 150,
    leaveVideoAction: "none"
  };

  var movieSlider;
  
  if($("#related-movie__slider .sp-slide").length > 1)
  {
    movieSlider = $('#related-movie__slider').sliderPro(option_movie);
    movieSlider.on("videoPlay", function(e){
      // 再生開始時の処理
      if(!g.gaMovieState[e.video[0].id])
      {
        g.gaMovieState[e.video[0].id] = true;
        ga('send', 'event', "Youtube", location.href, "movie_id" + e.video[0].id);
      }
    })
    .on("videoEnd", function(e){
      // 再生完了の処理
      g.gaMovieState[e.video[0].id] = false;
    })
    .on("gotoSlide", function(e){
      $(".sp-video").each(function(e){
        var _player = YT.get(this.id);
        var _state = _player.getPlayerState();
        if(g.ua == "android")
        {
          if(_state == YT.PlayerState.PLAYING || _state == YT.PlayerState.BUFFERING || YT.PlayerState.PAUSED) _player.stopVideo();
        }
        else
        {
          if(_state == YT.PlayerState.PLAYING || _state == YT.PlayerState.BUFFERING) _player.stopVideo();
        }
      });
    });
  }
  else
  {
    option_movie.loop = false;
    option_movie.touchSwipe = false;
    option_movie.thumbnailTouchSwipe = false;
    
    movieSlider = $('#related-movie__slider').sliderPro(option_movie);
    movieSlider.on("videoPlay", function(e){
      // 再生開始時の処理
      if(!g.gaMovieState[e.video[0].id])
      {
        g.gaMovieState[e.video[0].id] = true;
        ga('send', 'event', "Youtube", location.href, "movie_id" + e.video[0].id);
      }
    })
    .on("videoEnd", function(e){
      // 再生完了の処理
      g.gaMovieState[e.video[0].id] = false;
    })
    .on("gotoSlide", function(e){
      $(".sp-video").each(function(e){
        var _player = YT.get(this.id);
        var _state = _player.getPlayerState();
        if(g.ua == "android")
        {
          if(_state == YT.PlayerState.PLAYING || _state == YT.PlayerState.BUFFERING || YT.PlayerState.PAUSED) _player.stopVideo();
        }
        else
        {
          if(_state == YT.PlayerState.PLAYING || _state == YT.PlayerState.BUFFERING) _player.stopVideo();
        }
      });
    });
  }
}

$(".product-QandA__single, .product-QandA__single--opened").on("click", function(){
  if($(this).hasClass("isAnim")) return;
  var $this = $(this);
  $this.addClass("isAnim")

  if($(this).hasClass("product-QandA__single--opened"))
  {
    $this.find(".product-QandA__answer-container").slideUp(300, function(){
      $this.removeClass("product-QandA__single--opened isAnim")
      .addClass("product-QandA__single");
    });
  }
  else
  {
    $this.find(".product-QandA__answer-container").slideDown(300, function(){
      $this.addClass("product-QandA__single--opened")
      .removeClass("product-QandA__single isAnim")
    });
  }
});

//Btn Buy//
$(".action-btn__buy-inner").on("click", function(){
  if($(this).hasClass("isOpen")) otherClose("null");
  else
  {
    $(this).toggleClass("isOpen");
    $(".shop").fadeToggle(200);
    otherClose(".shop");
    checkModal();
    
    if($(this).hasClass("isOpen")) ga('send', 'event', "buy_link_open", location.href, "open");
  }
});

//Scroll to top//
$(".common-footer__btn-scroll-top").on("click", function(){
  $('body,html').animate({scrollTop:0}, 300, 'swing');
});


//Mouse Catcher//
$(document).on("touchstart", ".mouseCatcher", function(e){
  e.preventDefault();
  e.stopPropagation();
  
  otherClose("null");
});

function checkModal()
{
  if($(".search-container:visible").length != 0 ||
     $(".header-menu-list:visible").length != 0 ||
     $(".shop:visible").length != 0 ||
     $(".sort-selector.isOpen").length != 0)
  {
    mouseCatcher(true)
  }
  else mouseCatcher(false);
}

function mouseCatcher(flg)
{
  if(flg)
  {
    if($(".mouseCatcher").length == 0) $("body").prepend('<div class="mouseCatcher"></div>');
  }
  else $(".mouseCatcher").remove();
}

function otherClose(activeSelector)
{
  if(activeSelector != ".search-container")
  {
    $(".search-container:visible").addClass("isAnim").slideUp(300, function(){
      $(this).removeClass("isAnim");
      checkModal();
    });
  }

  if(activeSelector != ".header-menu-list")
  {
    $(".header-menu-list:visible").addClass("isAnim").slideUp(300, function(){
      $(this).removeClass("isAnim");
      checkModal();
    });
  }

  if(activeSelector != ".shop")
  {
    $(".action-btn__buy-inner").removeClass("isOpen");
    $(".shop").fadeOut(200, function(){
      checkModal();
    });
  }

  if(activeSelector != ".sort-selector")
  {
    $(".sort-selector, .product-list__sort-btn").removeClass("isOpen");
    checkModal();
  }
}

//Common menu//
$(document).on("click", ".common-menu__main-menu--closed .common-menu__main-menu-title", function(){
  $this = $(this);
  if($this.hasClass("isAnim")) return;
  
  $this.addClass("isAnim");
  $this.closest(".common-menu__main-menu--closed").addClass("common-menu__main-menu--opened")
  .removeClass("common-menu__main-menu--closed");
  
  $this.next().slideDown(300, function(){
    $this.removeClass("isAnim");
  });
});

$(document).on("click", ".common-menu__main-menu--opened .common-menu__main-menu-title", function(){
  $this = $(this);
  if($this.hasClass("isAnim")) return;
  
  $this.addClass("isAnim");
  $this.closest(".common-menu__main-menu--opened").addClass("common-menu__main-menu--closed")
  .removeClass("common-menu__main-menu--opened");
  
  $this.next().slideUp(300, function(){
    $this.removeClass("isAnim");
  });
});

$(document).on("click", ".common-menu__sub-menu--closed .common-menu__sub-menu-title", function(){
  $this = $(this);
  if($this.hasClass("isAnim")) return;
  
  $this.addClass("isAnim");
  $this.closest(".common-menu__sub-menu--closed").addClass("common-menu__sub-menu--opened")
  .removeClass("common-menu__sub-menu--closed");
  
  $this.next().slideDown(300, function(){
    $this.removeClass("isAnim");
  });
});

$(document).on("click", ".common-menu__sub-menu--opened .common-menu__sub-menu-title", function(){
  $this = $(this);
  if($this.hasClass("isAnim")) return;
  
  $this.addClass("isAnim");
  $this.closest(".common-menu__sub-menu--opened").addClass("common-menu__sub-menu--closed")
  .removeClass("common-menu__sub-menu--opened");
  
  $this.next().slideUp(300, function(){
    $this.removeClass("isAnim");
  });
});

//common menu header//
$(".common-header__menu").on("click", function(){
  $this = $(this);
  if($this.hasClass("isAnim")) return;
  
  $this.addClass("isAnim");
  $(".header-menu-list").slideToggle(300, function(){
    $this.removeClass("isAnim");
    checkModal();
  });
  checkModal();
  otherClose(".header-menu-list");
});

//serch box//
$(".common-header__search").on("click", function(){
  $this = $(this);
  if($this.hasClass("isAnim")) return;
  
  $this.addClass("isAnim");
  $(".search-container").slideToggle(300, function(){
    $this.removeClass("isAnim");
    checkModal();
  });
  checkModal();
  otherClose(".search-container");
});

//interest button//
$(document).on("click", ".btn-interest, .btn-interest-mini", function(e){
  e.preventDefault();
  e.stopPropagation();
  
  var _this = this;
  
  //uuidがなければ再取得//
  if(typeof g.uuid != "undefined") postEmotionalButton(_this);
  else
  {
    //UUIDを取得
    $.ajax({
      type: "GET",
      url: "/wp-json/emotional-button/load-user",
      xhrFields: {withCredentials: true},
      dataType: "json",
      timeout: 10000
    })
    .done(function(result){
      g.uuid = result.uuid;
      postEmotionalButton(_this);
    })
    .fail(function(result){
      g.errWindow.open();
      return false;
    })
  }
});

/**
 * 感情ボタンクリック送信
 * @param btn{HTMLElement} 押下したボタンのelement
 **/
function postEmotionalButton(btn)
{
  $.ajax({
    type: "POST",
    url: "/wp-json/emotional-button/push-button",
    xhrFields: {withCredentials: true},
    dataType: "json",
    timeout: 10000,
    data: {
      type: $(btn).attr("data-toy"),
      id: $(btn).attr("data-id"),
      uuid: g.uuid
    }
  })
  .done(function(result){
    if(result.isVote)
    {
      $(btn).find(".btn-interest__anim-container").each(function(i){
        var random = Math.random() * 60 + i * 120;
        var rotStr = "rotate(" + random + "deg)";
        $(this).css({
          transform: rotStr,
          "-webkit-transform": rotStr,
          "-moz-transform": rotStr,
        });
      });
      $(btn).addClass("isChecked");
    }
    else
    {
      $(btn).removeClass("active isChecked");
    }
    
    $(btn).find("[class*='__score']").text(result.count);
    
    setSegatoysCookie("param", "emotional_button",
      function(d){
        //ボタンの情報をオブジェクトに混ぜる
        d.label = result.label;
        d.id = result.id;
        setSegatoysCookieComplete(d, "emotional_button", btn)
      },
      function(d){setSegatoysCookieFailed(d, "emotional_button", btn)}
    );
    return false;
  })
  .fail(function(result){
    g.errWindow.open();
    return false;
  });
}

//Sort btn//
$(document).on("click", ".product-list__sort-btn", function(){
  $(this).toggleClass("isOpen");
  $(".sort-selector").toggleClass("isOpen");
  if($(this).hasClass("isOpen"))
  {
    checkModal();
    otherClose(".sort-selector");
  }
});

var sort = $('.product-list__sort-btn').attr('data-sort');
$('.sort-selector a[data-sort="'+ sort + '"]').addClass('isActive');



// 動画読み込み処理
function onYouTubeIframeAPIReady() {
  g.gaPlayers = {};
  g.gaMovieState = {};
  
  $(".sp-video").each(function(){
    var _id = this.src.replace(/http.*\//gi, "").replace(/\?.*/, "");
    this.id = _id;
  });
}

//contact
$(".contact__btn-contact").on("click", function(e){
  e.preventDefault();
  e.stopPropagation();
  var _this = this;
  
  setSegatoysCookie("param", "inquiry",
    function(d){setSegatoysCookieComplete(d, "inquiry", _this)},
    function(d){setSegatoysCookieFailed(d, "inquiry", _this)}
  );
});

//manual
$(".contact__btn-manual").on("click", function(e){
  e.preventDefault();
  e.stopPropagation();
  var _this = this;
  
  setSegatoysCookie("param", "download",
    function(d){setSegatoysCookieComplete(d, "download", _this)},
    function(d){setSegatoysCookieFailed(d, "download", _this)}
  );
});

//shop
$(".shop__name").on("click", function(e){
  e.preventDefault();
  e.stopPropagation();
  var _this = this;
  
  setSegatoysCookie("param", "conversion",
    function(d){setSegatoysCookieComplete(d, "conversion", _this)},
    function(d){setSegatoysCookieFailed(d, "conversion", _this)}
  );
})

/**
 * GA通知用文字列を返す
 * @param data {object} cookieとして保持しているオブジェクト
 */
function getCookieString(data)
{
  var _id = data.uuid;
  var _fd = data.first_visit_date;
  var _em = data.emotional_button;
  var _dl = data.download;
  var _eq = data.enquete;
  var _in = data.inquiry;
  var _cv = data.conversion;
  
  var str = "";
  str += "id" + _id + "," + "fd" + _fd + "," + "em" + _em + "," + "dl" + _dl + "," + "eq" + _eq + "," + "cv" + _cv + "," + "in" + _in;
  
  return str;
}

/**
 * cookieのロード
 * @param cb_done {function} 成功時のコールバック
 * @param cb_fail {function} 失敗時のコールバック
 */
//function getSegatoysCookie(cb_done, cb_fail)
//{
//  $.ajax({
//    type: "GET",
//    url: g.mainHost + "/wp-json/common/load",
//    xhrFields: {withCredentials: true},
//    dataType: "json",
//    timeout: 10000
//  })
//  .done(function(result){
//    cb_done(result);
//  })
//  .fail(function(result){
//    cb_fail(result);
//  });
//}

/**
 * cookieの書込み依頼
 * @param key {string} setするkey名
 * @param value {string} setする値
 * @param cb_done {function} 成功時のコールバック
 * @param cb_fail {function} 失敗時のコールバック
 */
function setSegatoysCookie(key, value, cb_done, cb_fail)
{
  var obj = {}
  obj[key] = value;
  
  $.ajax({
    type: "POST",
    url: g.mainHost + "/wp-json/common/set",
    xhrFields: {withCredentials: true},
    dataType: "json",
    timeout: 10000,
    data: obj
  })
  .done(function(result){
    cb_done(result);
  })
  .fail(function(result){
    cb_fail(result);
  });
}

/**
 * cookieの書込み成功ハンドラ
 * @param data {object} サーバーからの返り値
 * @param label {string} GAに紐づくアクションラベル
 * @param elm {htmlElement} イベントをトリガした要素
 */
function setSegatoysCookieComplete(data, label, elm)
{
  //GA送信後の共通コールバック処理
  var gaCallback = {
    hitCallback: function() {
      if(typeof window.open($(elm).attr("href"), "_blank") == "undefined") location.href = $(elm).attr("href");
    },
    hitCallbackFail: function(){
      if(typeof window.open($(elm).attr("href"), "_blank") == "undefined") location.href = $(elm).attr("href");
    }
  };
  
  var dataObj = {
    "event": label,
    "cookieStr": getCookieString(data)
  };
  
  //labelで処理分岐
  switch(label)
  {
    case "emotional_button":
      ga('send', 'event', label, location.href, data.label + data.id);
      dataObj.label = data.label + data.id;
      break;
      
    case "inquiry":
      ga('send', 'event', "inquiry_button", location.href, "https://enquete.segatoys.co.jp/inquiry/", gaCallback);
      break;
      
    case "download":
      ga('send', 'event', "manual", location.href, $(elm).attr("href"), gaCallback);
      break;
      
    case "conversion":
      ga('send', 'event', "buy_link", location.href, $(elm).attr("href"), gaCallback);
      break;
      
    //TODO: アンケートはまだ未実装
    //case "enquete":
    //  
    //  break;
  }

  dataLayer.push(dataObj);
}

/**
 * cookieの書込み失敗ハンドラ
 * @param data {object} サーバーからの返り値
 * @param label {string} GAに紐づくアクションラベル
 * @param elm {htmlElement} イベントをトリガした要素
 */
function setSegatoysCookieFailed(data, label, elm)
{
  //console.error("Failed: Set cookie::" + data);
  
  //labelで処理分岐
  switch(label)
  {
    case "inquiry":
      if(typeof window.open($(elm).attr("href"), "_blank") == "undefined") location.href = $(elm).attr("href");
      break;
      
    case "download":
      if(typeof window.open($(elm).attr("href"), "_blank") == "undefined") location.href = $(elm).attr("href");
      break;
      
    case "conversion":
      if(typeof window.open($(elm).attr("href"), "_blank") == "undefined") location.href = $(elm).attr("href");
      break;
      
    //TODO: アンケートはまだ未実装
    //case "enquete":
    //  if(typeof window.open($(elm).attr("href"), "_blank") == "undefined") location.href = $(elm).attr("href");
    //  break;
  }
}